module.exports = __webpack_public_path__ + "media/images/www/company/warehouse-2656365bdc20fe512fa23e842628512d.svg";